import { useI18n } from 'vue-i18n';
import { useAlert } from 'dashboard/composables';
import {
  ATTACHMENT_LIMIT_BYTES,
  isSupportedAttachment,
} from '../utils/supportTicketPortal';
import { useSupportTicketFormatters } from './useSupportTicketFormatters';

/**
 * Attachment validation + upload error mapping shared by the ticket creation
 * form, the reply form and the page level submit handlers.
 */
export function useSupportTicketAttachments() {
  const { t } = useI18n();
  const { attachmentLimitLabel, errorMessage } = useSupportTicketFormatters();

  const validFilesFrom = fileList => {
    const validFiles = [];
    Array.from(fileList || []).forEach(file => {
      if (file.size > ATTACHMENT_LIMIT_BYTES) {
        useAlert(
          t('SUPPORT_TICKETS.ATTACHMENTS.TOO_LARGE', {
            limit: attachmentLimitLabel.value,
          })
        );
        return;
      }
      if (!isSupportedAttachment(file)) {
        useAlert(t('SUPPORT_TICKETS.ATTACHMENTS.UNSUPPORTED'));
        return;
      }
      validFiles.push(file);
    });
    return validFiles;
  };

  const appendFiles = (form, fileList) => {
    const validFiles = validFilesFrom(fileList);
    form.attachments = [...form.attachments, ...validFiles];
  };

  const uploadErrorMessage = error => {
    const message = String(errorMessage(error)).toLowerCase();
    const status = error?.response?.status;
    if (status === 401 || status === 422 || message.includes('expired')) {
      return t('SUPPORT_TICKETS.ATTACHMENTS.EXPIRED');
    }
    if (status === 403 || message.includes('permission')) {
      return t('SUPPORT_TICKETS.ATTACHMENTS.FORBIDDEN');
    }
    if (status === 413 || message.includes('large')) {
      return t('SUPPORT_TICKETS.ATTACHMENTS.TOO_LARGE', {
        limit: attachmentLimitLabel.value,
      });
    }
    if (message.includes('partial')) {
      return t('SUPPORT_TICKETS.ATTACHMENTS.PARTIAL');
    }
    return errorMessage(error);
  };

  return {
    attachmentLimitLabel,
    appendFiles,
    uploadErrorMessage,
  };
}
